import { useState } from "react";
import { Download, FileDown, Linkedin, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { certImage, certPdf, certUrl, linkedInAddUrl, linkedInShareUrl } from "../../lib/learning";

const btn = "inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-colors";

export default function CertificateActions({ cert, compact = false }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(certUrl(cert.id)); } catch { /* clipboard unavailable */ }
    setCopied(true);
    toast.success("Certificate link copied");
    setTimeout(() => setCopied(false), 2000);
  };
  const pad = compact ? "px-4 py-2 text-xs" : "";
  return (
    <div className="flex flex-wrap gap-3" data-testid={`cert-actions-${cert.id}`}>
      <a href={linkedInAddUrl(cert)} target="_blank" rel="noreferrer" data-testid={`cert-linkedin-add-${cert.id}`} className={`${btn} ${pad} bg-[#0A66C2] text-white hover:bg-[#004182]`}>
        <Linkedin size={16} /> Add to LinkedIn profile
      </a>
      <a href={linkedInShareUrl(cert.id)} target="_blank" rel="noreferrer" data-testid={`cert-linkedin-share-${cert.id}`} className={`${btn} ${pad} border border-[#0A66C2] text-[#0A66C2] hover:bg-[#0A66C2]/5`}>
        <Share2 size={16} /> Share post
      </a>
      <a href={`${certImage(cert.id, "full", cert.version)}&download=true`} data-testid={`cert-download-png-${cert.id}`} className={`${btn} ${pad} bg-navy text-white hover:bg-navy-700`}>
        <Download size={16} /> PNG
      </a>
      <a href={certPdf(cert.id)} data-testid={`cert-download-pdf-${cert.id}`} className={`${btn} ${pad} border border-slate-300 text-navy hover:bg-slate-50`}>
        <FileDown size={16} /> PDF
      </a>
      <button onClick={copy} data-testid={`cert-copy-link-${cert.id}`} className={`${btn} ${pad} border border-slate-300 text-navy hover:bg-slate-50`}>
        <Link2 size={16} /> {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}
